module.exports = __webpack_public_path__ + "static/img/app.2090a23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/app.jpg
// module id = Maob
// module chunks = 0